global.$ = global.jQuery = require('jquery');

import 'jquery-ui';

require('./bootstrap');

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

//
// import { jsPDF } from "jspdf";
// window.jsPDF = jsPDF

// import 'bootstrap';
// import 'tw-elements';
import 'lity';
// import 'flowbite';
// import './flowbite.min'

import Quill from 'quill';

window.Quill = Quill;

import 'flowbite/dist/flowbite.js'

// import 'flowbite/dist/datepicker'
// import Datepicker from 'flowbite-datepicker/Datepicker';
//
// window.Datepicker = Datepicker;

import 'share-buttons';

import Mark from "mark.js/src/vanilla";

window.Mark = Mark;


import 'sortable-tablesort/sortable.min.js'

import Sortable, { MultiDrag, Swap } from 'sortablejs';
Sortable.mount(new MultiDrag(), new Swap());
window.Sortable = Sortable


var themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
var themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');

// Change the icons inside the button based on previous settings
if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    themeToggleLightIcon.classList.remove('hidden');
} else {
    themeToggleDarkIcon.classList.remove('hidden');
}

var themeToggleBtn = document.getElementById('theme-toggle');

themeToggleBtn.addEventListener('click', function () {

    // toggle icons inside button
    themeToggleDarkIcon.classList.toggle('hidden');
    themeToggleLightIcon.classList.toggle('hidden');

    // if set via local storage previously
    if (localStorage.getItem('color-theme')) {
        if (localStorage.getItem('color-theme') === 'light') {
            document.documentElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
        }

        // if NOT set via local storage previously
    } else {
        if (document.documentElement.classList.contains('dark')) {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
        } else {
            document.documentElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
        }
    }

});



/**
 *  disable submit button after form submit
 */
// Get all the forms on the page
const forms = document.getElementsByTagName('form');
// console.log(forms)
// Add an event listener to the submit event of each form
for (let i = 0; i < forms.length; i++) {
    forms[i].addEventListener('submit', function(event) {
        // Check if the form can be submitted
        if (this.hasAttribute('data-submitted')) {
            console.log('Form is already submitted');
            // Form has already been submitted, prevent further submissions
            event.preventDefault();
        } else {
            console.log('Form is being submitted')
            // Set an attribute to mark the form as submitted
            this.setAttribute('data-submitted', 'true');

            // Get the submit button of the form
            const submitButton = this.querySelector('button[type="submit"], input[type="submit"]');

            // Add the opacity-50 class to the submit button
            if (submitButton) {
                submitButton.classList.add('!opacity-50');
            }
        }
    });
}



// Conditionally log only in production
if (process.env.NODE_ENV === 'production') {

    const styles = [
        'background: linear-gradient(to right, #4CAF50, #2196F3, #FF9800);',
        'border: 2px solid #fff;',
        'color: #fff;',
        'padding: 2px;',
        'font-size: 12px;',
        'font-weight: bold;',
        'text-align: center;',
        'text-transform: uppercase;',
        'letter-spacing: 2px;',
        'line-height: 1.5;',
        'display: block;',
        'margin: 2px auto;',
        'border-radius: 5px;'
    ].join('');

    console.log('%c%c%c Hey there, curious developer! 🚀', styles, styles, styles);
    console.log('%c%c%c You found us! Feel free to explore, but remember - with great power comes great responsibility! ⚡ 🌌', styles, styles, styles);
    console.log('%c%c%c If you like what you see, join our team and help us build awesome things together! 🛠️ 💼', styles, styles, styles);
}
